import { Box } from "@mui/system";
import React, { Fragment } from "react";

const Ballon = ({ label, options = [], onChange, value }) => {
  return (
    <div className="flex flex-col gap-3">
      <label className="text-sm font-bold">{label} : </label>
      <div className="md:flex items-center gap-3 grid grid-cols-3">
        {options?.map((item) => (
          <Fragment key={item.id}>
            <Box
              className={`flex items-center
                  justify-center w-full md:w-fit md:px-4 rounded-lg transition duration-300 text-xs
                  py-2 border-[1px] border-solid  ${
                    value !== item.id ? "unSelectedBox" : "selectedBox"
                  }`}
              onClick={() => onChange(item?.id)}
            >
              {item.title}
            </Box>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default Ballon;
